function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Top3Organization = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Top = require("../../../components/Top3");
var _react = _interopRequireWildcard(require("react"));
var _Top3OrganizationController = require("./Top3OrganizationController");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _utils = require("../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["organizationId", "controller", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Top3Organization = exports.Top3Organization = function Top3Organization(_ref) {
  var _teams$sort, _teams$sort$items$fin, _members$sort, _members$sort$items$f;
  var organizationId = _ref.organizationId,
    _ref$controller = _ref.controller,
    controller = _ref$controller === void 0 ? new _Top3OrganizationController.Top3OrganizationController() : _ref$controller,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    leaderboardLinkUrl = _useContext.leaderboardLinkUrl,
    organizationTeamLeaderboardLinkUrl = _useContext.organizationTeamLeaderboardLinkUrl,
    todoListPageLinkUrl = _useContext.todoListPageLinkUrl;
  var _controller$useContro = controller.useController({
      organizationId: organizationId
    }),
    members = _controller$useContro.members,
    teams = _controller$useContro.teams,
    stepsTrying = _controller$useContro.stepsTrying,
    stepsCompleted = _controller$useContro.stepsCompleted;
  return (0, _jsxRuntime.jsxs)(_Top.Top3Container, Object.assign({
    style: style
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_Top.Top3, {
      title: t('top3Organization:teams.title'),
      subTitle: t('top3Organization:teams.subTitle'),
      actionLink: (0, _utils.ReplaceParam)(organizationTeamLeaderboardLinkUrl, organizationId),
      actionLabel: t('top3Organization:teams.actionLabel'),
      items: teams.items,
      sort: Object.assign({}, teams == null ? void 0 : teams.sort, {
        label: t('top3Organization:teams.sortLabel')
      }),
      showConfetti: true,
      valueSuffix: teams == null ? void 0 : (_teams$sort = teams.sort) == null ? void 0 : (_teams$sort$items$fin = _teams$sort.items.find(function (item) {
        var _teams$sort2;
        return item.id === (teams == null ? void 0 : (_teams$sort2 = teams.sort) == null ? void 0 : _teams$sort2.selectedId);
      })) == null ? void 0 : _teams$sort$items$fin.label,
      isLoading: teams == null ? void 0 : teams.isLoading
    }), (0, _jsxRuntime.jsx)(_Top.Top3, {
      title: t('top3Organization:members.title'),
      subTitle: t('top3Organization:members.subTitle'),
      actionLink: (0, _utils.ReplaceParam)(leaderboardLinkUrl, organizationId),
      actionLabel: t('top3Organization:members.actionLabel'),
      type: _Top.Top3Types.podium,
      items: members.items,
      showConfetti: true,
      valueSuffix: members == null ? void 0 : (_members$sort = members.sort) == null ? void 0 : (_members$sort$items$f = _members$sort.items.find(function (item) {
        var _members$sort2;
        return item.id === (members == null ? void 0 : (_members$sort2 = members.sort) == null ? void 0 : _members$sort2.selectedId);
      })) == null ? void 0 : _members$sort$items$f.label,
      sort: Object.assign({}, members == null ? void 0 : members.sort, {
        label: t('top3Organization:members.sortLabel')
      }),
      isLoading: members == null ? void 0 : members.isLoading
    }), (0, _jsxRuntime.jsx)(_Top.Top3, {
      title: t('top3Organization:stepsTrying.title'),
      subTitle: t('top3Organization:stepsTrying.subTitle'),
      items: stepsTrying == null ? void 0 : stepsTrying.items,
      actionLink: (0, _utils.ReplaceParam)(todoListPageLinkUrl, ''),
      actionLabel: t('top3Organization:stepsTrying.actionLabel'),
      isLoading: stepsTrying == null ? void 0 : stepsTrying.isLoading
    }), (0, _jsxRuntime.jsx)(_Top.Top3, {
      title: t('top3Organization:stepsCompleted.title'),
      subTitle: t('top3Organization:stepsCompleted.subTitle'),
      items: stepsCompleted == null ? void 0 : stepsCompleted.items,
      isLoading: stepsCompleted == null ? void 0 : stepsCompleted.isLoading
    })]
  }));
};